import { IEnvironment } from './environment.model';
import { microservices } from './microservices.az';
import { EMAIL_VALIDATOR_REGEX } from './environment.commonConfigurations';

const initialNavigation: any = 'disabled';
export const environment: IEnvironment = {
    WagePredictionService: `https://ipex-wage-prediction.prod.ipex.ch`,
    WagePredictionServiceUserName: `selise`,
    WagePredictionServicePassword: `ibexDerSteinbock#008`,
    BuildVersion: 'v1.526.0',
    IsAzStorage: true,
    production: true,
    IsStaging: true,
    beeUid: 'prod',
    isSSo: false,
    initialNavigation,
    /**
     * micro-sercice
     */
    Identity: `${microservices.prodBaseUrl}/${microservices.tenant.urlPrefix}/${microservices.tenant.prod}/TenantManager/TenantManagerQuery/GetIdentity`,
    Sites: `${microservices.prodBaseUrl}/${microservices.tenant.urlPrefix}/${microservices.tenant.prod}/TenantManager/SiteManagerQuery/GetSites`,
    Apps: `${microservices.prodBaseUrl}/${microservices.appCatalogue.urlPrefix}/${microservices.appCatalogue.prod}/AppCatalogue/AppManagerQuery/GetApps`,
    Security: `${microservices.prodBaseUrl}/${microservices.uam.urlPrefix}/${microservices.uam.prod}/UserAccessManagement/`,
    Token: `${microservices.prodBaseUrl}/${microservices.identity.urlPrefix}/${microservices.identity.prod}/identity/token`,
    SecurityIdentity: `${microservices.prodBaseUrl}/${microservices.identity.urlPrefix}/${microservices.identity.prod}/identity/`,
    Captcha: `${microservices.prodBaseUrl}/captcha/${microservices.captcha.prod}/captcha/CaptchaCommand/`,
    DataCore: `${microservices.prodBaseUrl}/pds/${microservices.pds.prod}/AppSuiteDataCore/`,
    Storage: `${microservices.prodBaseUrl}/${microservices.storageService.urlPrefix}/${microservices.storageService.prod}/StorageService/`,
    EmailService: `${microservices.prodBaseUrl}/${microservices.mailService.urlPrefix}/${microservices.mailService.prod}/MailService`,
    NotificationService: `${microservices.prodBaseUrl}/${microservices.notification.urlPrefix}/${microservices.notification.prod}`,
    AggregateService: `${microservices.prodBaseUrl}/${microservices.aggregator.urlPrefix}/${microservices.aggregator.prod}/Service-Aggregator/ServiceAggrigation/`,
    PdfGeneratorV2: `${microservices.prodBaseUrl}/${microservices.pdfGenerator2.urlPrefix}/${microservices.pdfGenerator2.prod}/PdfGeneratorHost/`,
    TemplateEngineService: `${microservices.prodBaseUrl}/${microservices.templateEngine.urlPrefix}/${microservices.templateEngine.prod}/TemplateEngineService/`,
    GQLQueryUri: `${microservices.prodBaseUrl}/${microservices.gqlQuery.urlPrefix}/${microservices.gqlQuery.prod}/graphql`,
    GQLMutationUri: `${microservices.prodBaseUrl}/${microservices.gqlCommand.urlPrefix}/${microservices.gqlCommand.prod}/graphql`,
    EmailSyncService: `${microservices.prodBaseUrl}/business-emailsync/EmailSyncService/`,
    PCXBusiness: `${microservices.prodBaseUrl}/business-pcx/PCXWebService/`,
    StaticResourceCDN: `https://prod-ecap.s3.eu-central-1.amazonaws.com/`,

    /**
     * Business-sercice
     */
    /**
     * Other config
     */

    CdnBaseUrl: `https://az-cdn.selise.biz/selisecdn/cdn/`,
    CdnTenantBaseUrl: `https://az-cdn.selise.biz/selisecdn/cdn/pcx/`,
    SiteLogo: `https://az-cdn.selise.biz/selisecdn/cdn/pcx/images/ipex_logo.svg`,
    topBgImageUrl: `https://az-cdn.selise.biz/selisecdn/cdn/pcx/`,
    action: `https://`,
    SubDomainName: `stage-ipex.selise.biz`,
    DomainName: `selise.biz`,
    SessionKey: `set_from_stage-ipex.selise.biz`,
    Client_ID: `8ABDFF27-1C30-4781-B3EF-1E6245314358`,
    NotificationHubName: `NotifierServerHub`,
    PersonFields: [
        `ItemId`,
        `CreatedBy`,
        `Tags`,
        `DateOfBirth`,
        `Sex`,
        `FirstName`,
        `LastName`,
        `ProfileImage`,
        `Email`,
        `DisplayName`,
        `ProfileImageId`,
        `IsVerified`,
        `Salutation`,
        `Nationality`,
        `PhoneNumber`,
        `Organization`,
        `OrganizationId`,
        `LastLogInTime`,
        `LogInCount`,
        `ColorCode`,
        `ProposedUserId`
    ],
    // toBgImages: [`backgrounds/top-bground.jpg`],
    toBgImages: [`backgrounds/zurich.png`],

    currentDateFormat: `dd MMM yyyy`,
    defaultLangKey: `en`,
    currency: `EUR`,
    landingUri: `https://app.ipex.ch`,
    language: [
        {
            id: `en`,
            title: `ENGLISH`,
            flag: `us`,
            value: `en-US`
        },
        {
            id: `de`,
            title: `GERMAN`,
            flag: `de`,
            value: `de-DE`
        },
        {
            id: `fr`,
            title: `FRENCH`,
            flag: `fr`,
            value: `fr-FR`
        },
        {
            id: `it`,
            title: `ITALIAN`,
            flag: `it`,
            value: `it-IT`
        }
    ],

    isFloatingChatPanelEnable: true,
    EmailValidatorRegex: EMAIL_VALIDATOR_REGEX,
    SiteId: 'CF55B6DF-585D-4AEF-8A71-43C11E8ACEA8',
    DefaultPackagePath: './assets/i18n/generic-app/',
    BuildPipelineId: 'baad454e-7566-43e7-a124-1aa290e770ad',
    MaintenanceManagerURL: `https://maintenancemanager.selise.biz/api/tenants`,
    JarowaWorkorderUrl: `https://enable.jarowa.ch/workOrderDetail/WORKORDER_ID/00000000-0000-0000-0000-000000000000`,
    caseCenterUri: 'https://case-center.ipex.ch',
    SlackWebHookUrl: 'https://hooks.slack.com/services/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',
    SlackAdminWebHookUrl: 'https://hooks.slack.com/services/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',
    ClaimCenterUri: "https://selise-repair-center.prod.ipex.ch",
    IpexFileService : 'https://ipex-file-service.prod.ipex.ch',
    IpexDataBeastService : 'https://ipex-data-beast.prod.ipex.ch',
    ClaimCenterLinkBaseUri: "https://selise-repair-center.prod.ipex.ch",
    UILMUrl: 'https://api.seliseblocks.com/uilm/v1/Key/GetUilmFile',
    ProjectKey: '48E6EE8275AF45B08C44EA814835C1E5',
    AutoClearingUserId: '8fb2b75b-38cb-4c50-869e-ca76a2e4a8b0'
};

export const environmentProd = environment;
